import React from "react";
import styled from "styled-components";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import { FormGrid, FormikForm } from "../../../../../forms";
import { ActionButtons } from "../../../../../forms/ActionButtons";
import { inputs } from "../../../../../inputs/inputConfigs";
import { projectServiceDataComponentId } from "../ProjectServiceContainer";

const Wrapper = styled.div``;

const fields = {
  groups: [
    {
      items: [
        {
          input: inputs.name,
          grid: { xs: 12 },
        },
      ],
    },
  ],
};

export const CreateProjectService = ({
  handleCreateProjectService,
  closeModalDialog,
}) => {
  return (
    <FormikForm
      initialValues={{ name: "" }}
      onSubmit={handleCreateProjectService}
      validationSchema={BWModels.loadSchema("ProjectService")}
    >
      {({ handleSubmit, values, ...formikProps }) => (
        <Wrapper>
          <FormGrid fields={fields} {...formikProps} />
          <ActionButtons
            onSend={handleSubmit}
            onCancel={closeModalDialog}
            sendButtonText="Create"
            listeners={[projectServiceDataComponentId]}
            isModal
          />
        </Wrapper>
      )}
    </FormikForm>
  );
};
